
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metal-solutions/industries/medical-systems",
      function () {
        return require("private-next-pages/metal-solutions/industries/medical-systems/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/metal-solutions/industries/medical-systems"])
      });
    }
  